/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!***************************************************!*\
  !*** ./src/assets/js/featured-product-section.js ***!
  \***************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FeaturedProductSection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FeaturedProductSection, _HTMLElement);

  var _super = _createSuper(FeaturedProductSection);

  function FeaturedProductSection() {
    var _this;

    _classCallCheck(this, FeaturedProductSection);

    _this = _super.call(this);
    _this.selectors = {
      section: '.featured-product-section',
      mainSlider: '.mySwiper2',
      thumbSlider: '.mySwiper',
      reviewsSlider: '.reviews-swiper',
      productForm: 'product-form',
      variants: '.bundle-selector__item',
      variantPrice: '.bundle-price',
      productPrice: '.product-price',
      productInput: 'input[name="id"]',
      subscription: '[data-subscription]',
      currentVariantTitle: '.current-variant-title',
      currentSubscribeTitle: '.current-subscribe',
      stickyBar: '.sticky-featured-product',
      stickyAddToCard: '[data-sticky-add-to-card]',
      headerBuyBtn: '[data-buy-btn]',
      addToCartBtn: 'button[type="submit"]',
      activeForm: '.form-check.active',
      scrollButton: '[data-product-scroll]',
      faqItem: '.faq__item',
      faqQuestion: '.faq__question'
    };
    _this.modificators = {
      active: 'active',
      open: 'open',
      enabled: 'enabled',
      headerOpen: 'headerOpen',
      subscribed: 'subscribed'
    };
    _this.plans = JSON.parse(_this.dataset.plans);
    _this.mainSlider = null;
    _this.thumbSlider = null;
    _this.reviewsSlider = null;
    _this.currentStatus = _this.querySelector('.current-status');
    _this.cart = document.querySelector('cart-drawer');
    _this.thumbAmount = parseFloat(_this.dataset.thumbs);
    _this.currency = _this.getAttribute('data-currency');
    _this.currencySymbol = _this.getAttribute('data-currency-symbol');
    return _this;
  }

  _createClass(FeaturedProductSection, [{
    key: "initSliders",
    value: function initSliders() {
      var mainSlider = this.querySelector(this.selectors.mainSlider);
      var thumbSlider = this.querySelector(this.selectors.thumbSlider);
      var reviewsSlider = this.querySelector(this.selectors.reviewsSlider);
      var nextButton = this.querySelector('.swiper-button-next');
      var prevButton = this.querySelector('.swiper-button-prev');
      var scrollbar = this.querySelector('.swiper-scrollbar');

      if (thumbSlider != null) {
        var thumbSliderOptions = {
          slidesPerView: this.thumbAmount,
          spaceBetween: 10,
          centeredSlides: false,
          centeredSlidesBounds: false,
          breakpoints: {
            992: {
              slidesPerView: this.thumbAmount
            }
          }
        };

        if (Swiper !== undefined) {
          this.thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
        }
      }

      if (reviewsSlider != null) {
        var reviewsNextButton = reviewsSlider.querySelector('.swiper-button-next');
        var reviewsPrevButton = reviewsSlider.querySelector('.swiper-button-prev');
        var reviewsPagination = reviewsSlider.querySelector('.swiper-pagination');
        var reviewsSliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          centeredSlidesBounds: true,
          navigation: {
            nextEl: reviewsNextButton,
            prevEl: reviewsPrevButton
          },
          pagination: {
            el: reviewsPagination
          }
        };

        if (Swiper !== undefined) {
          this.reviewsSlider = new Swiper(reviewsSlider, reviewsSliderOptions);
        }
      }

      if (mainSlider !== null) {
        var mainSliderOptions = {
          slidesPerView: 1,
          spaceBetween: 30,
          centeredSlides: false,
          centeredSlidesBounds: false,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          scrollbar: {
            el: scrollbar
          },
          thumbs: {
            swiper: this.thumbSlider
          }
        };

        if (Swiper !== undefined) {
          this.mainSlider = new Swiper(mainSlider, mainSliderOptions);
        }

        this.cart = document.querySelector('cart-drawer');
      }
    }
  }, {
    key: "changeSliderSlide",
    value: function changeSliderSlide(variantTitle) {
      console.log('change slider slide', variantTitle);
      var slideIndex = this.mainSlider.slides.reduce(function (acc, item, index) {
        var image = item.querySelector('img');

        if (image.alt === variantTitle) {
          acc = index;
        }

        return acc;
      }, 0);
      this.mainSlider.slideTo(slideIndex);
    }
  }, {
    key: "onChangeVariant",
    value: function onChangeVariant(currentTarget) {
      var _this2 = this;

      // new - st39
      if (document.querySelector('.pdp-variant--force-show')) {
        var container = currentTarget.querySelector('.banner_top_bundle') || currentTarget.querySelector('.varient_image_bundle');
        var regualarWasPrice = container.dataset.regularWasPrice;
        var regualarPerBottle = container.dataset.regularPerBottle;
        var regualarPerServing = container.dataset.regularPerServing;
        var regualarSaving = container.dataset.regularSaving;
        var subscribeWasPrice = container.dataset.subscribeWasPrice;
        var subscribePerBottle = container.dataset.subscribePerBottle;
        var subscribePerServing = container.dataset.subscribePerServing;
        var subscribeSaving = container.dataset.subscribeSaving;
        var currentStatus = this.currentStatus;
        var activeForm = this.querySelector(this.selectors.activeForm);
        var variantTitle = currentTarget.dataset.variantFullTitle;
        var frequency_time = this.querySelectorAll('.frequency-holder');

        if (frequency_time) {
          frequency_time.forEach(function (item) {
            item.textContent = currentTarget.dataset.month;
          });
        }

        this.changeSliderSlide(variantTitle);

        if (currentStatus && activeForm.dataset.subscribe == 'true') {
          var priceEach = currentTarget.querySelector('.varient_price_sub').innerHTML;

          if (document.querySelector('.pdp-variant--force-show')) {
            this.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "<s>Was: <span>".concat(subscribeWasPrice, "</span></s>  <b>").concat(subscribePerBottle, " Per Bottle / ").concat(subscribePerServing, " Per Serving</b>");
            this.currentStatus.querySelector('.current-status__save-price').innerHTML = "<b>You're Saving</b> <span>".concat(subscribeSaving, "</span>");
          } else {
            this.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "".concat(priceEach.replace('Each', '').replace('per bundle', '')).concat(this.currency === 'AUD' && ' AUD' || this.currency === 'CAD' && ' CAD' || '', " Per Bottle");
            this.currentStatus.querySelector('.current-status__save-price').innerHTML = "You're Saving ".concat(activeItem.querySelector('[data-subscribesave]').dataset.subscribesave, " with Subscribe and Save");
            this.currentStatus.style.display = 'block';
          }
        } else {
          this.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "<s>Was: <span>".concat(regualarWasPrice, "</span></s>  <b>").concat(regualarPerBottle, " Per Bottle / ").concat(regualarPerServing, " Per Serving</b>");
          this.currentStatus.querySelector('.current-status__save-price').innerHTML = "<b>You're Saving</b> <span>".concat(regualarSaving, "</span>");
        }

        var activeVariants = this.querySelectorAll("".concat(this.selectors.variants, ".").concat(this.modificators.active));
        activeVariants.forEach(function (activeVariant) {
          activeVariant.classList.remove(_this2.modificators.active);
        });
        var newActiveVariantsId = currentTarget.getAttribute('data-variant-id');
        var newActiveVariants = this.querySelectorAll("".concat(this.selectors.variants, "[data-variant-id=\"").concat(newActiveVariantsId, "\"]"));
        newActiveVariants.forEach(function (variant) {
          variant.classList.add(_this2.modificators.active);
        });
        var productPrices = this.querySelectorAll(this.selectors.productPrice);
        var variantPrice = currentTarget.querySelector(this.selectors.variantPrice);
        productPrices.forEach(function (price) {
          if (currentTarget.classList.contains(_this2.modificators.subscribed)) {
            if (price.closest('.sticky-featured-product')) {
              var newPrice = currentTarget.dataset.subPrice;
              newPrice = +newPrice * currentTarget.dataset.productsQuantity;
              price.innerHTML = "".concat(_this2.currencySymbol).concat(newPrice.toFixed(2));
            } else {
              price.innerHTML = currentTarget.querySelector('.varient_price_sub').innerHTML;
            }
          } else {
            price.innerHTML = variantPrice.innerHTML;
          }
        });
        var productInput = this.querySelector(this.selectors.productInput);
        var currentVariantId = currentTarget.getAttribute('data-variant-id');
        productInput.value = currentVariantId;
        var variantTitles = this.querySelectorAll(this.selectors.currentVariantTitle);
        variantTitles.forEach(function (title) {
          title.innerHTML = currentTarget.getAttribute('data-variant-title');
        });
      } // old texts
      else {
        var _currentStatus = this.currentStatus;

        var _activeForm = this.querySelector(this.selectors.activeForm);

        var _variantTitle = currentTarget.dataset.variantFullTitle;

        var _frequency_time = this.querySelectorAll('.frequency-holder');

        if (_frequency_time) {
          _frequency_time.forEach(function (item) {
            item.textContent = currentTarget.dataset.month;
          });
        }

        this.changeSliderSlide(_variantTitle);

        if (_currentStatus && _activeForm.dataset.subscribe == 'true') {
          _currentStatus.style.display = 'block';
          var _priceEach = currentTarget.querySelector('.varient_price_sub').innerHTML;
          this.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "".concat(_priceEach.replace('Each', '').replace('per bundle', '')).concat(this.currency === 'AUD' && ' AUD' || this.currency === 'CAD' && ' CAD' || '', " Per Bottle");
          this.currentStatus.querySelector('.current-status__save-price').innerHTML = "You're Saving ".concat(currentTarget.querySelector('[data-subscribesave]').dataset.subscribesave, " with Subscribe and Save");
        }

        var _activeVariants = this.querySelectorAll("".concat(this.selectors.variants, ".").concat(this.modificators.active));

        _activeVariants.forEach(function (activeVariant) {
          activeVariant.classList.remove(_this2.modificators.active);
        });

        var _newActiveVariantsId = currentTarget.getAttribute('data-variant-id');

        var _newActiveVariants = this.querySelectorAll("".concat(this.selectors.variants, "[data-variant-id=\"").concat(_newActiveVariantsId, "\"]"));

        _newActiveVariants.forEach(function (variant) {
          variant.classList.add(_this2.modificators.active);
        });

        var _productPrices = this.querySelectorAll(this.selectors.productPrice);

        var _variantPrice = currentTarget.querySelector(this.selectors.variantPrice);

        _productPrices.forEach(function (price) {
          if (currentTarget.classList.contains(_this2.modificators.subscribed)) {
            if (price.closest('.sticky-featured-product')) {
              var newPrice = currentTarget.dataset.subPrice;
              newPrice = +newPrice * currentTarget.dataset.productsQuantity;
              price.innerHTML = "".concat(_this2.currencySymbol).concat(newPrice.toFixed(2));
            } else {
              price.innerHTML = currentTarget.querySelector('.varient_price_sub').innerHTML;
            }
          } else {
            price.innerHTML = _variantPrice.innerHTML;
          }
        });

        var _productInput = this.querySelector(this.selectors.productInput);

        var _currentVariantId = currentTarget.getAttribute('data-variant-id');

        _productInput.value = _currentVariantId;

        var _variantTitles = this.querySelectorAll(this.selectors.currentVariantTitle);

        _variantTitles.forEach(function (title) {
          title.innerHTML = currentTarget.getAttribute('data-variant-title');
        });
      }
    }
  }, {
    key: "onChangeSubscription",
    value: function onChangeSubscription(currentTarget) {
      var _this3 = this;

      var isSubscription = currentTarget.getAttribute('data-subscribe');
      var newTitle = currentTarget.querySelector('label');
      var subscribeTitle = this.querySelectorAll(this.selectors.currentSubscribeTitle);
      var activeSubscription = this.querySelectorAll("".concat(this.selectors.subscription, ".").concat(this.modificators.active));
      var newActiveSubscriptions = this.querySelectorAll("".concat(this.selectors.subscription, "[data-subscribe=\"").concat(isSubscription, "\"]"));
      var addToCartButton = this.querySelector(this.selectors.addToCartBtn);
      var frequency_time = this.querySelectorAll('.frequency-holder');
      var active_item = this.querySelector('.bundle-selector__item.active').dataset.month;

      if (frequency_time && active_item) {
        frequency_time.forEach(function (item) {
          item.textContent = active_item;
        });
      }

      activeSubscription.forEach(function (subscription) {
        subscription.classList.remove(_this3.modificators.active);
      });
      newActiveSubscriptions.forEach(function (newSubscription) {
        newSubscription.classList.add(_this3.modificators.active);
      });
      subscribeTitle.forEach(function (title) {
        title.innerHTML = newTitle.innerHTML;
      });

      if (isSubscription == 'true') {
        if (this.querySelector('.subscribes-label')) {
          this.querySelector('.subscribes-label').classList.remove('hidden');
        }
      } else {
        if (this.querySelector('.subscribes-label')) {
          this.querySelector('.subscribes-label').classList.add('hidden');
        }
      }

      if (addToCartButton) {
        if (isSubscription == 'true') {
          addToCartButton.textContent = 'SUBSCRIBE NOW';
        } else {
          addToCartButton.textContent = 'Add to cart';
        }
      } // 23.01.25 update - changed document.querySelectorAll to this.querySelectorAll


      var variants = this.querySelectorAll(this.selectors.variants);
      var productPrices = this.querySelectorAll(this.selectors.productPrice);

      var activeVariant = _toConsumableArray(this.querySelectorAll("".concat(this.selectors.variants, ".").concat(this.modificators.active))).filter(function (variant) {
        return !variant.classList.contains('sticky-variant');
      })[0];

      variants.forEach(function (variant) {
        var activeVariantItem = _this3.querySelector("".concat(_this3.selectors.variants, ".").concat(_this3.modificators.active));

        var container = activeVariantItem.querySelector('.banner_top_bundle') || activeVariantItem.querySelector('.varient_image_bundle');
        var regualarWasPrice = container.dataset.regularWasPrice;
        var regualarPerBottle = container.dataset.regularPerBottle;
        var regualarPerServing = container.dataset.regularPerServing;
        var regualarSaving = container.dataset.regularSaving;
        var subscribeWasPrice = container.dataset.subscribeWasPrice;
        var subscribePerBottle = container.dataset.subscribePerBottle;
        var subscribePerServing = container.dataset.subscribePerServing;
        var subscribeSaving = container.dataset.subscribeSaving;

        if (isSubscription == 'true') {
          if (variant.querySelector('.discount_bs')) {
            variant.querySelector('.discount_bs').style.display = 'none';
          }

          if (variant.querySelector('.varient_price_bs') && !variant.classList.contains('sticky-variant')) {
            variant.querySelector('.varient_price_bs').style.display = 'none';
          }

          if (variant.querySelector('.varient_price_sub') && !variant.classList.contains('sticky-variant')) {
            variant.querySelector('.varient_price_sub').style.display = 'block';
          }

          variant.classList.add(_this3.modificators.subscribed);
          productPrices.forEach(function (price) {
            if (price.closest('.sticky-featured-product')) {
              var newPrice = activeVariant.dataset.subPrice;
              newPrice = +newPrice * activeVariant.dataset.productsQuantity;
              price.innerHTML = "".concat(_this3.currencySymbol).concat(newPrice.toFixed(2));
            } else {
              price.innerHTML = activeVariant.querySelector('.varient_price_sub').innerHTML;
            }
          });

          var _activeItem = _this3.querySelector("".concat(_this3.selectors.variants, ".").concat(_this3.modificators.active));

          var priceEach = _activeItem.querySelector('.varient_price_sub').innerHTML;

          if (document.querySelector('.pdp-variant--force-show')) {
            _this3.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "<s>Was: <span>".concat(subscribeWasPrice, "</span></s>  <b>").concat(subscribePerBottle, " Per Bottle / ").concat(subscribePerServing, " Per Serving</b>");
            _this3.currentStatus.querySelector('.current-status__save-price').innerHTML = "<b>You're Saving</b> <span>".concat(subscribeSaving, "</span>");
          } else {
            _this3.currentStatus.style.display = 'block';
            _this3.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "".concat(priceEach.replace('Each', '').replace('per bundle', ''), " Per Bottle");
            _this3.currentStatus.querySelector('.current-status__save-price').innerHTML = "You're Saving ".concat(_activeItem.querySelector('[data-subscribesave]').dataset.subscribesave, " with Subscribe and Save");
          }
        } else {
          console.log('NOT SUBSCRIPTION');

          if (variant.querySelector('.discount_bs')) {
            variant.querySelector('.discount_bs').style.display = 'inline-flex';
          }

          if (!variant.classList.contains('sticky-variant') && variant.querySelector('.varient_price_bs')) {
            variant.querySelector('.varient_price_bs').style.display = 'block';
          }

          if (!variant.classList.contains('sticky-variant') && variant.querySelector('.varient_price_sub')) {
            variant.querySelector('.varient_price_sub').style.display = 'none';
          }

          variant.classList.remove(_this3.modificators.subscribed);
          productPrices.forEach(function (price) {
            price.innerHTML = activeVariant.querySelector('.bundle-price').innerHTML;
          });

          if (document.querySelector('.pdp-variant--force-show')) {
            _this3.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "<s>Was: <span>".concat(regualarWasPrice, "</span></s>  <b>").concat(regualarPerBottle, " Per Bottle / ").concat(regualarPerServing, " Per Serving</b>");
            _this3.currentStatus.querySelector('.current-status__save-price').innerHTML = "<b>You're Saving</b> <span>".concat(regualarSaving, "</span>");
          } else {
            _this3.currentStatus.style.display = 'none';
          }
        }
      });
    }
  }, {
    key: "onScrollToSection",
    value: function onScrollToSection(event) {
      var Ycoords = this.getBoundingClientRect().top + window.pageYOffset;

      if (window.innerWidth <= 1024) {
        Ycoords = this.querySelector('.pdp-variant').getBoundingClientRect().top + window.pageYOffset;
      }

      event.preventDefault();
      window.scrollTo({
        top: Ycoords,
        behavior: 'smooth'
      });
    }
  }, {
    key: "onShowStickyBar",
    value: function onShowStickyBar() {
      var stickyBar = this.querySelector(this.selectors.stickyBar);
      stickyBar.classList.add(this.modificators.open);
    }
  }, {
    key: "onHideStickyBar",
    value: function onHideStickyBar() {
      var stickyBar = this.querySelector(this.selectors.stickyBar);
      stickyBar.classList.remove(this.modificators.open);
    }
  }, {
    key: "onAddToCart",
    value: function () {
      var _onAddToCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(variant_id, qty, frequency, unit_type, selling_plan_id, ignore_click, mainProductId) {
        var _this4 = this;

        var data;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  id: variant_id,
                  quantity: qty
                }; // Add hide_quantity property if it exists

                if (mainProductId) {
                  data['properties'] = _objectSpread(_objectSpread({}, data['properties']), {}, {
                    __hide_quantity: mainProductId
                  });
                } // Only add the selling_plan and properties if selling_plan_id exists


                if (selling_plan_id) {
                  data['selling_plan'] = selling_plan_id;
                  data['properties'] = {
                    shipping_interval_frequency: frequency,
                    shipping_interval_unit_type: unit_type
                  };
                }

                data['sections'] = this.cart.getSectionsToRender().map(function (section) {
                  return section.id;
                });
                data['sections_url'] = window.location.pathname;
                _context.next = 7;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data)
                }).then(function (response) {
                  return response.json();
                }).then(function (response) {
                  _this4.cart.renderContents(response);

                  setTimeout(function () {
                    _this4.cart.checkFreeProducts();

                    _this4.cart.updateProgressBar();
                  });

                  if (!ignore_click) {
                    document.querySelector('button.cart-icon').click();
                  }

                  if (window.location.href.includes('gleefull-quiz-result')) {
                    if (document.querySelector('#cart-icon-bubble .item_count')) {
                      console.log('cart-icon-bubble');
                      var items = document.querySelector('#cart-icon-bubble .item_count').getAttribute('data-items');
                      document.querySelector('#cart-icon-bubble .item_count').setAttribute('data-items', parseInt(items) + 1);
                      document.querySelector('#cart-icon-bubble .item_count').innerHTML = parseInt(items) + 1;
                      console.log(document.querySelector('#cart-icon-bubble .item_count').getAttribute('data-items'), document.querySelector('#cart-icon-bubble .item_count').innerHTML);
                    } else {
                      setTimeout(function () {
                        _this4.refetchCounter();
                      }, 300);
                    }
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onAddToCart(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _onAddToCart.apply(this, arguments);
      }

      return onAddToCart;
    }()
  }, {
    key: "extractMonths",
    value: function extractMonths(str) {
      var parts = str.split('/');
      var monthPart = parts[1];
      var numberOfMonths = monthPart.replace(/[^\d]/g, '');
      return parseInt(numberOfMonths, 10);
    }
  }, {
    key: "isProductInCart",
    value: function () {
      var _isProductInCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(variant_id) {
        var cart;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch('/cart.js').then(function (response) {
                  return response.json();
                });

              case 2:
                cart = _context2.sent;
                return _context2.abrupt("return", cart.items.some(function (item) {
                  return item.id === parseInt(variant_id);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function isProductInCart(_x8) {
        return _isProductInCart.apply(this, arguments);
      }

      return isProductInCart;
    }()
  }, {
    key: "onAddToCartClick",
    value: function onAddToCartClick(event) {
      var _this5 = this;

      if (this.querySelector(this.selectors.activeForm).dataset.subscribe == 'true') {
        event.preventDefault();
        var current_option = this.querySelector('.bundle-selector__item.active').textContent;
        var current_id = this.querySelector('.variant__id').value;
        var frequency = parseInt(this.querySelector('.bundle-selector__item.active').dataset.month);
        var unit_type = frequency == 1 ? 'Month' : 'Months';
        var selling_plans = this.plans[0].selling_plans;
        var matchingPlan = selling_plans.find(function (plan) {
          return plan.name === "Delivered every ".concat(frequency, " month").concat(frequency > 1 ? 's' : '');
        });
        var selling_plan_id = null;

        if (matchingPlan) {
          selling_plan_id = matchingPlan.id;
        }

        if (selling_plan_id) {
          this.onAddToCart(current_id, 1, frequency, unit_type, selling_plan_id); // if url contains 'gleefull-quiz-result"
        } else {
          console.error('No applicable selling plan found.');
        }

        setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
          var activeProductElement, variant_id, productInCart, mainProductId, activeSubscribeProductElement, _mainProductId, _variant_id, _productInCart;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  activeProductElement = document.querySelector('.bundle-selector__item.cursor-pointer.active[data-additional-product]');
                  console.log('activeProductSubscribeElement', activeSubscribeProductElement);

                  if (!activeProductElement) {
                    _context3.next = 9;
                    break;
                  }

                  variant_id = activeProductElement.getAttribute('data-additional-product');
                  _context3.next = 6;
                  return _this5.isProductInCart(variant_id);

                case 6:
                  productInCart = _context3.sent;
                  mainProductId = activeProductElement.getAttribute('data-main-additional-product');

                  if (!productInCart) {
                    _this5.onAddToCart(variant_id, 1, null, null, null, true, mainProductId);
                  }

                case 9:
                  activeSubscribeProductElement = document.querySelector('.bundle-selector__item.cursor-pointer.active[data-additional-subscribe-product]');

                  if (!activeSubscribeProductElement) {
                    _context3.next = 17;
                    break;
                  }

                  _mainProductId = activeSubscribeProductElement.getAttribute('data-main-additional-product');
                  _variant_id = activeSubscribeProductElement.getAttribute('data-additional-subscribe-product');
                  _context3.next = 15;
                  return _this5.isProductInCart(_variant_id);

                case 15:
                  _productInCart = _context3.sent;

                  if (!_productInCart && activeSubscribeProductElement.classList.contains(_this5.modificators.subscribed)) {
                    _this5.onAddToCart(_variant_id, 1, null, null, null, true, _mainProductId);
                  }

                case 17:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })), 2500);
      } else {
        event.preventDefault();
        var variantId = this.querySelector('.variant__id').value;
        this.onAddToCart(variantId, 1, null, null, null, false); //document.querySelector('button#cart-icon-bubble').click();

        setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
          var activeProductElement, variant_id, mainProductId, productInCart, activeSubscribeProductElement, _mainProductId2, _variant_id2, _productInCart2;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  activeProductElement = document.querySelector('.bundle-selector__item.cursor-pointer.active[data-additional-product]');

                  if (!activeProductElement) {
                    _context4.next = 8;
                    break;
                  }

                  variant_id = activeProductElement.getAttribute('data-additional-product');
                  mainProductId = activeProductElement.getAttribute('data-main-additional-product');
                  _context4.next = 6;
                  return _this5.isProductInCart(variant_id);

                case 6:
                  productInCart = _context4.sent;

                  if (!productInCart) {
                    _this5.onAddToCart(variant_id, 1, null, null, null, true, mainProductId);
                  }

                case 8:
                  activeSubscribeProductElement = document.querySelector('.bundle-selector__item.cursor-pointer.active[data-additional-subscribe-product]');

                  if (!activeSubscribeProductElement) {
                    _context4.next = 16;
                    break;
                  }

                  _mainProductId2 = activeSubscribeProductElement.getAttribute('data-main-additional-product');
                  _variant_id2 = activeSubscribeProductElement.getAttribute('data-additional-subscribe-product');
                  _context4.next = 14;
                  return _this5.isProductInCart(_variant_id2);

                case 14:
                  _productInCart2 = _context4.sent;

                  if (!_productInCart2 && activeSubscribeProductElement.classList.contains(_this5.modificators.subscribed)) {
                    _this5.onAddToCart(_variant_id2, 1, null, null, null, true, _mainProductId2);
                  }

                case 16:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })), 2500);

        if (window.location.href.includes('gleefull-quiz-result')) {
          if (document.querySelector('#cart-icon-bubble .item_count')) {
            var items = document.querySelector('#cart-icon-bubble .item_count').getAttribute('data-items');
            document.querySelector('#cart-icon-bubble .item_count').setAttribute('data-items', parseInt(items) + 1);
            document.querySelector('#cart-icon-bubble .item_count').innerHTML = parseInt(items) + 1;
          } else {
            setTimeout(function () {
              _this5.refetchCounter();
            }, 300);
          }
        }
      }
    }
  }, {
    key: "refetchCounter",
    value: function refetchCounter() {
      fetch('/').then(function (response) {
        return response.text();
      }).then(function (data) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var cartBubble = doc.querySelector('#cart-icon-bubble');
        document.querySelector('#cart-icon-bubble').innerHTML = cartBubble.innerHTML;
      });
    }
  }, {
    key: "initIntersectionObserver",
    value: function initIntersectionObserver() {
      var _this6 = this;

      var stickyBar = this.querySelector(this.selectors.stickyBar);
      var featuredProductSections = document.querySelectorAll('.featured-product-section');
      var isMobile = window.innerWidth <= 1024;
      if (!stickyBar) return;

      if (isMobile) {
        stickyBar.classList.add(this.modificators.enabled);
      } // Initially hide the sticky bar


      this.onHideStickyBar();

      var checkStickyBarVisibility = function checkStickyBarVisibility() {
        var stickyBarPosition = stickyBar.getBoundingClientRect().top;
        var windowScrollY = window.scrollY;
        var showStickyBar = true; // Check if we are above the first featured product section

        if (featuredProductSections.length > 0) {
          var firstSectionPosition = featuredProductSections[0].getBoundingClientRect().top + windowScrollY; //console.log(windowScrollY, firstSectionPosition)

          if (windowScrollY < firstSectionPosition) {
            // We are above the first featured product section, do not show sticky bar
            showStickyBar = false;
          } else {
            // Check if any featured product section is currently in the viewport
            var _iterator = _createForOfIteratorHelper(featuredProductSections),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var section = _step.value;
                var sectionTop = section.getBoundingClientRect().top + windowScrollY;
                var sectionBottom = sectionTop + section.offsetHeight;

                if (windowScrollY + window.innerHeight > sectionTop && windowScrollY < sectionBottom) {
                  // Current viewport is overlapping a featured product section, do not show sticky bar
                  showStickyBar = false;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        if (showStickyBar) {
          _this6.onShowStickyBar();
        } else {
          _this6.onHideStickyBar();
        }
      }; // Attach the scroll event listener


      window.addEventListener('scroll', checkStickyBarVisibility); // Call once on initialization to set the correct state

      checkStickyBarVisibility();
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this7 = this;

      var variants = this.querySelectorAll(this.selectors.variants);
      var subscriptions = this.querySelectorAll(this.selectors.subscription);
      var stickyBtn = this.querySelector(this.selectors.stickyAddToCard);
      var headerBuyButton = document.querySelector(this.selectors.headerBuyBtn);
      var stickyBar = this.querySelector(this.selectors.stickyBar);
      var addToCartBtn = this.querySelector(this.selectors.addToCartBtn);
      var faqItems = this.querySelectorAll(this.selectors.faqItem);
      var faqQuestions = this.querySelectorAll(this.selectors.faqQuestion);
      document.addEventListener('click', function (e) {
        var target = e.target;

        if (target.getAttribute('data-product-scroll')) {
          _this7.onScrollToSection(e);
        }
      });

      if (variants.length) {
        variants.forEach(function (variant) {
          variant.addEventListener('click', function (_ref3) {
            var currentTarget = _ref3.currentTarget;

            _this7.onChangeVariant(currentTarget);
          });
        });
      }

      if (subscriptions.length) {
        subscriptions.forEach(function (subscription) {
          subscription.addEventListener('click', function (_ref4) {
            var currentTarget = _ref4.currentTarget;

            _this7.onChangeSubscription(currentTarget);
          });
        });
      }

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function (event) {
          if (addToCartBtn) {
            event.preventDefault();
            document.querySelector('button.primary-btn.btn_full_width.mb-1.cart-btn.mt-auto.w-full').click();
          } else {
            _this7.onScrollToSection(event);
          }
        });
      }

      if (headerBuyButton) {
        headerBuyButton.addEventListener('click', function (event) {
          _this7.onScrollToSection(event);
        });
      }

      if (stickyBar) {
        document.addEventListener('showHeader', function () {
          stickyBar.classList.add(_this7.modificators.headerOpen);
        });
        document.addEventListener('hideHeader', function () {
          stickyBar.classList.remove(_this7.modificators.headerOpen);
        });
      }

      if (addToCartBtn) {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.addEventListener('click', function (event) {
          _this7.onAddToCartClick(event);
        });
      }

      if (faqQuestions.length) {
        faqQuestions.forEach(function (faqQuestion) {
          faqQuestion.addEventListener('click', function (event) {
            faqItems.forEach(function (item) {
              if (item !== faqQuestion.parentElement) {
                item.removeAttribute('open');
              }

              setTimeout(function () {
                if (item.hasAttribute('open')) {
                  var itemTop = item.getBoundingClientRect().top + window.scrollY;
                  var windowHeight = window.innerHeight; // Scroll to center the opened item

                  window.scrollTo({
                    top: itemTop + 100 - windowHeight / 2,
                    behavior: 'smooth'
                  });
                }
              });
            });
          });
        });
      }
    }
  }, {
    key: "initSubscriptionPrices",
    value: function initSubscriptionPrices() {
      var _this8 = this;

      var getMonth = function getMonth(string) {
        // const parts = string.split('/');
        // const monthPart = parts[1];
        // const numberOfMonths = monthPart.replace(/[^\d]/g, '');
        // return parseInt(numberOfMonths, 10)
        return string.split(' ')[0];
      };

      var variants = this.querySelectorAll(this.selectors.variants);
      variants.forEach(function (variant) {
        var variantInformationWrapper = variant.querySelector('.varient_image_bundle');
        var currentPrice = variant.querySelector('.varient_price_bs').innerHTML.match(/\d+(\.\d+)?/g);
        var month = getMonth(variant.querySelector('.varient_tittle_bs').innerHTML);

        var currentPlan = _this8.plans[0].selling_plans.filter(function (plan) {
          return plan.name.includes(month);
        })[0];

        var percent = currentPlan.price_adjustments[0].value;
        var subscribePrice = (currentPrice - currentPrice * percent / 100).toFixed(2);
        var newPriceString = variant.querySelector('.varient_price_bs').innerHTML.replace(/\d+(\.\d+)?/g, subscribePrice);
        var newPriceElement = document.createElement('span');
        variant.setAttribute('data-sub-price', subscribePrice);
        newPriceElement.classList.add('varient_price_sub');
        newPriceElement.classList.add('hidden');
        newPriceElement.innerHTML = newPriceString;
        variantInformationWrapper.appendChild(newPriceElement);
      });
    }
  }, {
    key: "initStatusPrice",
    value: function initStatusPrice() {
      var _this9 = this;

      var currentTargets = this.querySelectorAll("".concat(this.selectors.variants, ".active"));
      currentTargets.forEach(function (currentTarget) {
        if (currentTarget.classList.contains('sticky-variants')) return;
        var container = currentTarget.querySelector('.banner_top_bundle') || currentTarget.querySelector('.varient_image_bundle');
        var regualarWasPrice = container.dataset.regularWasPrice;
        var regualarPerBottle = container.dataset.regularPerBottle;
        var regualarPerServing = container.dataset.regularPerServing;
        var regualarSaving = container.dataset.regularSaving;
        var subscribeWasPrice = container.dataset.subscribeWasPrice;
        var subscribePerBottle = container.dataset.subscribePerBottle;
        var subscribePerServing = container.dataset.subscribePerServing;
        var subscribeSaving = container.dataset.subscribeSaving;
        _this9.currentStatus.querySelector('.current-status__price-bottle').innerHTML = "<s>Was: <span>".concat(regualarWasPrice, "</span></s>  <b>").concat(regualarPerBottle, " Per Bottle / ").concat(regualarPerServing, " Per Serving</b>");
        _this9.currentStatus.querySelector('.current-status__save-price').innerHTML = "<b>You're Saving</b> <span>".concat(regualarSaving, "</span>");
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this10 = this;

      setTimeout(function () {
        if (_this10.getAttribute('data-plans').length) {
          _this10.initSubscriptionPrices();
        }

        if (document.querySelector('.pdp-variant--force-show')) {
          _this10.initStatusPrice();
        }

        _this10.initSliders();

        _this10.initListeners();

        _this10.initIntersectionObserver();

        _this10.initFakeDropdown(); // Initialize dropdown logic
        // Select the first option by default


        var firstOption = _this10.querySelector('.fake-select-option.active');

        console.log('firstOption', firstOption);

        if (firstOption) {
          _this10.selectOption(firstOption);
        }
      }, 500);
    }
  }]);

  return FeaturedProductSection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (customElements.get('featured-product') === undefined) {
  customElements.define('featured-product', FeaturedProductSection);
}
})();

/******/ })()
;